"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Lang_js_1 = require("../Lang.js");
function formatDate(dateString) {
    var date = new Date(dateString);
    var month = '' + (date.getMonth() + 1), day = '' + date.getDate(), year = date.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('-');
}
function SubscriptionStatus(_a) {
    var renewal = _a.renewal;
    return (react_1.default.createElement("div", { className: "form-group button-status" },
        react_1.default.createElement(Typography_1.default, { variant: "h6", className: "section-title" },
            (0, Lang_js_1.__)('Subscription status'),
            ":"),
        renewal.subscription_status !== 'OK' ? (react_1.default.createElement(Box_1.default, null,
            react_1.default.createElement(Box_1.default, { className: "alert-message" },
                react_1.default.createElement(Typography_1.default, { variant: "h6", sx: { color: 'white' } },
                    (0, Lang_js_1.__)('Your subscription expired on'),
                    " ",
                    formatDate(renewal.renewal_needed_by),
                    ". "),
                react_1.default.createElement(Typography_1.default, { variant: "body1", sx: { color: 'white' } }, (0, Lang_js_1.__)('Please click the button below to renew your primary subscription before submitting your application.'))),
            react_1.default.createElement(Button_1.default, { variant: "contained", className: "alert-button", href: "/shop/product-category/subscriptions/", target: "_blank", rel: "noopener noreferrer" }, (0, Lang_js_1.__)('RENEW SUBSCRIPTION HERE')),
            react_1.default.createElement(Typography_1.default, { variant: "body1" }, (0, Lang_js_1.__)('If you are currently unable to renew your primary subscription to Discourses/SATs, it is still important to submit your ministerial renewal application by your birthday to avoid a late renewal fee. In addition, please contact Order@msia.org for assistance with next steps to renew your Discourse/SAT subscription.')))) : (react_1.default.createElement(Typography_1.default, { variant: "body1", className: "status-ok" },
            (0, Lang_js_1.__)('You are up-to-date with your active primary subscription. Your subscription expires on'),
            " ",
            renewal.renewal_needed_by,
            "."))));
}
exports.default = SubscriptionStatus;
